import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 28px;

  .ads {
    margin: 0 auto;
    max-width: 900px;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 16px;
    margin-top: 4px;
  }
`;
